import React, { useState } from "react";
import { FiUpload } from "react-icons/fi";
import { baseUrl } from '../../shared';
import {
  Button,
  TextField,
  MenuItem,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  LinearProgress
} from "@mui/material";

export default function SafetyEssentialsUpload({ foundAsset, onSuccess }) {
  const [files, setFiles] = useState([]); // [{ file, progress }]
  const [attachmentType, setAttachmentType] = useState("");
  const [open, setOpen] = useState(false); // modal
  const [uploading, setUploading] = useState(false);
  const [dragActive, setDragActive] = useState(false);
  var [weblink, setWebLink] = useState("");
  var [weblinkname, setWeblinkname] = useState("");

  // 📂 Add files from input or drop
  const addFiles = (selected) => {
    const newFiles = Array.from(selected).map((file) => ({
      file,
      progress: 0,
    }));
    setFiles((prev) => [...prev, ...newFiles]);
  };

  const handleFileChange = (e) => {
    if (e.target.files) addFiles(e.target.files);
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      addFiles(e.dataTransfer.files);
    }
  };

  // 🚀 Upload files in parallel with XHR
  const handleUpload = () => {
  if (!attachmentType) return;

  // --- WEBLINK upload (different endpoint) ---
  if (attachmentType === "LINK") {
    if (!weblink) return;

    setOpen(true);
    setUploading(true);

    const xhr = new XMLHttpRequest();
    xhr.open("POST", baseUrl + "uploadWebLink");
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader("username", localStorage.getItem("username"));
    xhr.setRequestHeader("bToken", localStorage.getItem("bToken"));
    xhr.setRequestHeader("catNo", foundAsset.catNo);
    xhr.setRequestHeader("attachmentType", "SAFETY_ESSENTIALS");

    xhr.onload = () => {
      setOpen(false);
      onSuccess();
      setUploading(false);
      setFiles([]);
      setAttachmentType("");
    };

    xhr.onerror = () => {
      console.error("WebLink upload failed");
      setOpen(false);
      setUploading(false);
    };

    // Payload for a link (no FormData/files)
    xhr.send(JSON.stringify({ url: weblink, urlName: weblinkname }));
    return;
  }

  // --- PHOTO / VIDEO file uploads ---
  if (files.length === 0) return;

  setOpen(true);
  setUploading(true);

  let completed = 0;

  files.forEach((f, idx) => {
    const formData = new FormData();
    formData.append("myFile", f.file);

    const xhr = new XMLHttpRequest();
    xhr.open("POST", baseUrl + "upload");

    xhr.setRequestHeader("username", localStorage.getItem("username"));
    xhr.setRequestHeader("bToken", localStorage.getItem("bToken"));
    xhr.setRequestHeader("catNo", foundAsset.catNo);
    xhr.setRequestHeader("attachmentType", "SAFETY_ESSENTIALS");

    // progress
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable) {
        const percent = Math.round((e.loaded * 100) / e.total);
        setFiles(prev => {
          const updated = [...prev];
          updated[idx] = { ...updated[idx], progress: percent };
          return updated;
        });
      }
    };

    xhr.onload = () => {
      completed++;
      if (completed === files.length) {
        setOpen(false);
        onSuccess();
        setUploading(false);
        setFiles([]);
        setAttachmentType("");
      }
    };

    xhr.onerror = () => {
      console.error("Upload failed:", f.file.name);
      completed++;
      if (completed === files.length) {
        setOpen(false);
        setUploading(false);
      }
    };

    xhr.send(formData);
  });
};

  return (
    <div>
      {/* Uploading Modal */}
      <Dialog open={open} onClose={() => !uploading && setOpen(false)}>
        <DialogTitle>Upload Safety Essential</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {uploading ? "Uploading. Please wait…" : "Done"}
          </DialogContentText>
          {files.map((f, i) => (
            <div key={i} style={{ marginTop: "8px" }}>
              <div>{f.file.name}</div>
              <LinearProgress
                variant="determinate"
                value={f.progress}
                sx={{ height: 8, borderRadius: 5 }}
              />
            </div>
          ))}
        </DialogContent>
      </Dialog>

      {/* File Upload UI with drag & drop */}
      <form
        onSubmit={(e) => e.preventDefault()}
        className={`uploadBox ${dragActive ? "drag-active" : ""}`}
        onDragEnter={handleDrag}
        onDragOver={handleDrag}
        onDragLeave={handleDrag}
        onDrop={handleDrop}
      >
        <TextField select
          label="Select Upload Type"
          fullWidth
          value={attachmentType}
          onChange={(e) => setAttachmentType(e.target.value)}
        >
          <MenuItem value="PHOTO/VIDEO">Photo/Video</MenuItem>
          <MenuItem value="LINK">Web Link</MenuItem>
        </TextField>

        {attachmentType === 'PHOTO/VIDEO' ? (
        <div>
        {files.length > 0 ? (
          <ul>
            {files.map((f, i) => (
              <li key={i}>{f.file.name}</li>
            ))}
          </ul>
        ) : (
          <FiUpload className="upload-icon" />
        )}</div>):null}


{attachmentType === 'PHOTO/VIDEO' ? (
        <div className="drag">
          Drop your files here or{" "}
          <label>
            <input
              type="file"
              multiple
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
            <Button component="span" variant="outlined">
              Browse Files
            </Button>
          </label>
        </div>):null}

        {attachmentType === 'PHOTO/VIDEO' ? (<p className="info">Supports Photo & Video Files</p>):null}
        <br />
        {attachmentType === 'LINK' ?(
        <>
        <TextField
            label="Friendly Name"
            value={weblinkname}
            style={{width:'85%'}} 
            onChange={(e) => setWeblinkname(e.target.value)}
          />
          <br />
        <TextField
            label="Weblink URL"
            value={weblink}
            style={{width:'85%'}} 
            onChange={(e) => setWebLink(e.target.value)}
          />
          </>):null}

        <Button
          variant="contained"
          
          onClick={handleUpload}
          disabled={uploading || attachmentType === "" || (files.length === 0 && (!weblink || !weblinkname))}
          sx={{ mt: 2 }}
        >
          Upload
        </Button>
      </form>
    </div>
  );
}
